import React from 'react';
import { Box, Text } from 'ink';
import type { UpdateInfo } from '../../types';
import { useTheme } from '../theme';

export interface UpdateBannerProps {
  updateInfo: UpdateInfo;
  columns: number;
}

export const UpdateBanner: React.FC<UpdateBannerProps> = ({ updateInfo, columns }) => {
  const { tokens } = useTheme();
  return (
    <Box
      borderStyle="round"
      borderColor={tokens.text.warning}
      paddingX={1}
      marginBottom={1}
      flexDirection="column"
      width={columns}
    >
      <Text bold color={tokens.text.warning}>
        Update available
      </Text>
      <Box>
        <Text dimColor>{updateInfo.currentVersion}</Text>
        <Text> → </Text>
        <Text color={tokens.text.success}>{updateInfo.latestVersion}</Text>
      </Box>
      <Text color={tokens.text.accent}>{updateInfo.installCommand}</Text>
    </Box>
  );
};
